import { render, staticRenderFns } from "./CreateEditTest.vue?vue&type=template&id=015a7284&"
import script from "./CreateEditTest.vue?vue&type=script&lang=js&"
export * from "./CreateEditTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports